import { Check } from "lucide-react";
import { Logo } from "./Logo";

interface LoyaltyCardProps {
  business?: string;
  filled?: number;
  total?: number;
  member?: string;
  reward?: string;
}

export function LoyaltyCard({
  business = "Boulangerie Le Fournil",
  filled = 5,
  total = 8,
  member = "Sophie M.",
  reward = "8ᵉ offert",
}: LoyaltyCardProps) {
  return (
    <div className="rounded-2xl bg-ink p-5 text-white shadow-xl">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-white/50">
            Carte de fidélité
          </p>
          <p className="text-base font-bold">{business}</p>
        </div>
        <div className="text-right">
          <p className="text-[10px] uppercase tracking-wide text-white/50">Tampons</p>
          <p className="text-xl font-extrabold">
            {filled}
            <span className="text-white/50">/{total}</span>
          </p>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-4 gap-2">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className={`flex aspect-square items-center justify-center rounded-full ${
              i < filled ? "bg-gradient-brand" : "bg-white/10"
            }`}
          >
            {i < filled && <Check size={14} strokeWidth={3} />}
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3 text-xs">
        <div>
          <p className="text-white/50">Récompense</p>
          <p className="font-semibold">{reward}</p>
        </div>
        <div className="text-right">
          <p className="text-white/50">Membre</p>
          <p className="font-semibold">{member}</p>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-between rounded-lg bg-white/5 px-2 py-1.5">
        <Logo className="scale-75 origin-left" dark />
        <span className="text-[10px] text-white/50">Wallet</span>
      </div>
    </div>
  );
}
